import { registerQuery, useQuery } from 'data-fetching-client';
import { getEcosystemClient } from 'marketplace-ui-common/clients/ecosystemClient';
const GET_APP_INTEGRATION_TAGS_FIELD_NAME = 'appIntegrationTags';
const GET_APP_INTEGRATION_TAGS = registerQuery({
  fieldName: GET_APP_INTEGRATION_TAGS_FIELD_NAME,
  fetcher: ({
    appContext
  }) => {
    const client = getEcosystemClient(appContext);
    return client.get('apps/tags/app-integrations');
  }
});
export function useAppIntegrationTags(appContext) {
  return useQuery(GET_APP_INTEGRATION_TAGS, {
    variables: {
      appContext
    }
  });
}